import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = '/api';
const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c', GREEN = '#22a06b';

export default function AppNotifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const phone = localStorage.getItem('userPhone') || '';
        if (phone) {
          const r = await axios.get(`${API}/bookings/customer/${phone}`, { timeout: 12000 });
          const bookings = Array.isArray(r.data) ? r.data : [];
          // Turn bookings into notification-style items
          const notifs = bookings.map(b => {
            const st = (b.status || 'pending').toLowerCase();
            if (st === 'confirmed' || st === 'accepted')
              return { icon: '✅', color: GREEN, title: 'Booking Confirmed', body: `${b.salon_name || 'Salon'} confirmed your booking for ${b.booking_date} ${b.slot_time}`, date: b.booking_date };
            if (st === 'rejected')
              return { icon: '❌', color: '#dc2626', title: 'Booking Not Available', body: `${b.salon_name || 'Salon'} could not take your booking. Try another slot.`, date: b.booking_date };
            if (st === 'completed')
              return { icon: '⭐', color: '#4338ca', title: 'How was your visit?', body: `Rate your experience at ${b.salon_name || 'the salon'}`, date: b.booking_date };
            return { icon: '⏳', color: '#b45309', title: 'Booking Received', body: `Your booking at ${b.salon_name || 'salon'} is waiting for confirmation`, date: b.booking_date };
          });
          setItems(notifs);
        }
      } catch (e) { setItems([]); }
      setLoading(false);
    };
    load();
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '20px 16px', display: 'flex', alignItems: 'center', gap: 14 }}>
        <span onClick={() => navigate('/app/profile')} style={{ fontSize: 24, cursor: 'pointer' }}>‹</span>
        <div style={{ fontSize: 18, fontWeight: 700 }}>Notifications</div>
      </div>

      <div style={{ padding: 16 }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40, color: GREY }}>Loading...</div>
        ) : items.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 50, color: GREY }}>
            <div style={{ fontSize: 50 }}>🔔</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: INK, marginTop: 12 }}>No notifications yet</div>
            <div style={{ fontSize: 13, marginTop: 6 }}>Booking updates will show up here.</div>
          </div>
        ) : (
          items.map((n, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: 14, padding: 14, display: 'flex', gap: 12, marginBottom: 10, boxShadow: '0 2px 8px rgba(28,28,40,.04)' }}>
              <div style={{ width: 40, height: 40, borderRadius: 10, background: '#fdf2f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>{n.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: INK }}>{n.title}</div>
                <div style={{ fontSize: 13, color: GREY, marginTop: 3, lineHeight: 1.4 }}>{n.body}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
